<template>
  <OmitBlock :element="block">
    <div :class="block.style">
      <template v-for="inlineObject in block.inlineObjects">
        <!-- {{inlineObject.className}} - {{inlineObject.id}} -->
        <AmountEntry
          v-if="inlineObject.className == 'AmountEntry'"
          :amountEntry="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
          @updated="updated($event)"
        />
        <AmountField
          v-if="inlineObject.className == 'AmountField'"
          :element="inlineObject"
          :key="inlineObject.id"
        />
        <BoxEntry
          v-if="inlineObject.className == 'BoxEntry'"
          :boxEntry="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
          @updated="updated($event)"
        />
        <BoxZ v-if="inlineObject.className == 'BoxZ'" :boxz="inlineObject" :key="inlineObject.id" />
        <DateEntry
          v-if="inlineObject.className == 'DateEntry'"
          :dateEntry="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
          @updated="updated($event)"
        />
        <DateField
          v-if="inlineObject.className == 'DateField'"
          :element="inlineObject"
          :key="inlineObject.id"
        />
        <Inline
          v-if="inlineObject.className == 'Inline'"
          :inline="inlineObject"
          :key="inlineObject.id"
        />
        <Link v-if="inlineObject.className == 'Link'" :link="inlineObject" :key="inlineObject.id" />
        <LoginClient
          v-if="inlineObject.className == 'LoginClient'"
          :loginClient="inlineObject"
          :key="inlineObject.id"
        />
        <LoginDetails
          v-if="inlineObject.className == 'LoginDetails'"
          :loginDetails="inlineObject"
          :key="inlineObject.id"
        />
        <Lookup
          v-if="inlineObject.className == 'Lookup'"
          :lookup="inlineObject"
          :key="inlineObject.id"
        />
        <MultiEntry
          v-if="inlineObject.className == 'MultiEntry'"
          :multiEntry="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
          @updated="updated($event)"
        />
        <MultiEntryOption
          v-if="inlineObject.className == 'MultiEntryOption'"
          :multiEntryOption="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
        />
        <Signature
          v-if="inlineObject.className == 'Signature'"
          :signature="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
        />
        <SignatureEntry
          v-if="inlineObject.className == 'SignatureEntry'"
          :signatureEntry="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
          @updated="updated($event)"
        />
        <TextEntry
          v-if="inlineObject.className == 'TextEntry'"
          :textEntry="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
          @updated="updated($event)"
        />
        <TextField
          v-if="inlineObject.className == 'TextField'"
          :element="inlineObject"
          :key="inlineObject.id"
        />
        <UploadEntry
          v-if="inlineObject.className == 'UploadEntry'"
          :uploadEntry="inlineObject"
          :entryItems="entryItems"
          :key="inlineObject.id"
          @updated="updated($event)"
        />
      </template>
    </div>
  </OmitBlock>
</template>

<script>
import AmountEntry from "@/components/document/fill/inline/AmountEntry";
import AmountField from "@/components/document/fill/inline/AmountField";
import BoxEntry from "@/components/document/fill/inline/BoxEntry";
import BoxZ from "@/components/document/fill/inline/BoxZ";
import DateEntry from "@/components/document/fill/inline/DateEntry";
import DateField from "@/components/document/fill/inline/DateField";
import Inline from "@/components/document/fill/inline/Inline";
import Link from "@/components/document/fill/inline/Link";
import LoginClient from "@/components/document/fill/inline/LoginClient";
import LoginDetails from "@/components/document/fill/inline/LoginDetails";
import Lookup from "@/components/document/fill/inline/Lookup";
import MultiEntry from "@/components/document/fill/inline/MultiEntry";
import MultiEntryOption from "@/components/document/fill/inline/MultiEntryOption";
import Signature from "@/components/document/fill/inline/Signature";
import SignatureEntry from "@/components/document/fill/inline/SignatureEntry";
import TextEntry from "@/components/document/fill/inline/TextEntry";
import TextField from "@/components/document/fill/inline/TextField";
import UploadEntry from "@/components/document/fill/inline/UploadEntry";
import OmitBlock from "@/components/document/fill/OmitBlock";
export default {
  name: "Block",
  props: ["block", "entryItems"],
  components: {
    AmountEntry,
    AmountField,
    BoxEntry,
    BoxZ,
    DateEntry,
    DateField,
    Inline,
    Link,
    LoginClient,
    LoginDetails,
    Lookup,
    MultiEntry,
    MultiEntryOption,
    Signature,
    SignatureEntry,
    TextEntry,
    TextField,
    UploadEntry,
    OmitBlock
  },
  methods: {
    updated(event) {
      this.$emit("updated", event);
      // console.log(copy)
    }
    // updatedInlineObject(event, index) {
    //   let copy = JSON.parse(JSON.stringify(this.block));
    //   copy.inlineObjects[index] = event;
    //   // console.log(copy)
    //   this.$emit("updated", copy);
    // }
  }
};
</script>
